import React, { createContext, useEffect } from 'react'
import { MTM_EVENT_TYPES } from '../utils/matomo'
import useTracker from '../hooks/useTracker'
import useRawState from '../hooks/useRawState'

/** @type {import('react').Context<any>} */
const ProfileContext = createContext({})
export default ProfileContext

export function ProfileProvider(props) {
    const profileResult = useRawState('/api/current/profile')

    const track = useTracker()

    useEffect(() => {

        const { data } = profileResult
        // early return if we have no data yet
        if (!data) return
        // if non-admin, track
        if (!data?.admin) {
            track({ 'event': MTM_EVENT_TYPES.login })
        } else {
            console.log('SETTING DO-NOT-TRACK FOR ADMIN')
            // if admin, manually set tracking ignore cookie for the session
            document.cookie = `mtm_consent_removed=${new Date().getTime()}; SameSite=Lax;`
        }
        
    }, [profileResult])

    return (
        <ProfileContext.Provider
            value={profileResult}
            {...props}
        />
    )
}
